// @ts-nocheck
export const FETCH_COUNTRY_BASE_CURRENCY = 'FETCH_COUNTRY_BASE_CURRENCY';
export const FETCH_BASE_CURRENCY = 'FETCH_BASE_CURRENCY';
export const SET_COUNTRY_BASE_CURRENCY = 'SET_COUNTRY_BASE_CURRENCY';
export const SET_BASE_CURRENCY = 'SET_BASE_CURRENCY';

export const fetchCountryBaseCurrency = (country, token) => {
  return {
    data: {
      country,
      token
    },
    type: FETCH_COUNTRY_BASE_CURRENCY
  };
};

export const fetchBaseCurrency = (baseCurrency, token) => {
  return {
    data: {
      baseCurrency,
      token
    },
    type: FETCH_BASE_CURRENCY
  };
};

export const setCountryBaseCurrency = baseCurrencyData => {
  return {
    data: {
      baseCurrencyData
    },
    type: SET_COUNTRY_BASE_CURRENCY
  };
};

export const setBaseCurrency = baseCurrencyData => {
  return {
    data: {
      baseCurrencyData
    },
    type: SET_BASE_CURRENCY
  };
};
